module.exports = function () {
  return "\n    <div class=\"conquistadors-overlay\" id=\"conquistadors-overlay\">\n    </div>\n  ";
};